module.exports = "<div class=rm-fbc-tooltip><div class=fbc-id><%=fareBasisCode%></div></div>";